import { render, staticRenderFns } from "./payqrcodepayrecord.vue?vue&type=template&id=2667fbcb&scoped=true&"
import script from "./payqrcodepayrecord.vue?vue&type=script&lang=js&"
export * from "./payqrcodepayrecord.vue?vue&type=script&lang=js&"
import style0 from "./payqrcodepayrecord.vue?vue&type=style&index=0&id=2667fbcb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2667fbcb",
  null
  
)

export default component.exports